// theme.ts — the active Bootswatch mode (Darkly ↔ Flatly) as a React hook.
//
// Every chart and every palette-solved color in this SPA has to re-solve
// when the user flips the navbar's theme toggle, and the toggle's only
// observable effect is `data-bs-theme` on <html> (DESIGN.md C-BOOT-2).
// One MutationObserver per consumer, shared through this hook, so no page
// hand-rolls the observer again.
import { useEffect, useState } from 'react';

export type ThemeMode = 'dark' | 'light';

export function themeMode(): ThemeMode {
  if (typeof document === 'undefined') return 'dark';
  return document.documentElement.dataset.bsTheme === 'light' ? 'light' : 'dark';
}

export function useThemeMode(): ThemeMode {
  const [mode, setMode] = useState<ThemeMode>(themeMode);
  useEffect(() => {
    const obs = new MutationObserver(() => setMode(themeMode()));
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme'],
    });
    return () => obs.disconnect();
  }, []);
  return mode;
}
